import React from 'react'

const Autoplay4 = ({ color = '#323232' }) => {
  return (
    <svg
      version={1.0}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      className="cursor-pointer w-full h-full"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M3315 3836 c-181 -30 -381 -108 -523 -204 l-59 -41 -764 -4 c-836 -4
  -802 -2 -978 -66 -461 -168 -738 -647 -655 -1132 62 -361 315 -667 653 -789
  180 -65 143 -63 980 -67 l764 -4 59 -41 c91 -61 272 -144 375 -172 450 -120
  917 2 1243 324 189 186 309 408 366 672 25 116 25 380 0 496 -56 263 -176 484
  -360 667 -178 177 -398 296 -646 350 -102 22 -352 28 -455 11z m362 -321 c489
  -94 824 -513 800 -1000 -28 -539 -478 -949 -1015 -922 -364 18 -677 229 -834
  563 -67 145 -82 215 -82 404 0 138 4 178 22 243 78 284 272 514 536 637 74 35
  197 73 271 83 72 10 230 6 302 -8z m-1272 -287 c-69 -112 -133 -276 -167 -433
  -17 -82 -17 -380 1 -470 28 -142 97 -322 166 -433 l27 -43 -599 3 c-661 4
  -642 3 -788 72 -178 84 -305 229 -371 421 -25 72 -28 94 -28 215 0 122 3 143
  28 215 78 225 240 386 461 459 93 30 167 34 733 35 l563 1 -26 -42z"
        />
        <path
          d="M3239 3187 c-103 -29 -171 -88 -218 -187 l-26 -55 0 -385 0 -385 26
  -55 c37 -79 81 -125 157 -162 55 -27 76 -32 136 -32 51 0 85 6 119 22 85 38
  611 346 648 379 19 17 48 56 65 85 26 48 29 62 29 148 0 86 -3 100 -29 148
  -17 29 -46 68 -65 85 -37 33 -564 342 -644 377 -58 26 -141 33 -198 17z m354
  -470 c141 -82 257 -153 257 -157 0 -8 -485 -291 -522 -305 -17 -7 -18 12 -18
  305 0 247 3 311 13 308 7 -2 128 -70 270 -151z"
        />
      </g>
    </svg>
  )
}

export default Autoplay4
